import { render, staticRenderFns } from "./promotion_term.vue?vue&type=template&id=530a3100&"
import script from "./promotion_term.vue?vue&type=script&lang=js&"
export * from "./promotion_term.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports